import React from 'react';
import SpanSpinner from '../../../../Shared/SpanSpinner/SpanSpinner';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import './ExistingMember.scss';
import { Col, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { createAccount } from '../../../../../Redux/Actions/AccountCreateActions';
import { validationService } from '../../../../../services/validation.service';
import { NavLink } from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Alert } from 'reactstrap';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import { history } from '../../../../../helpers/history';

import ExistingUserSuccess from '../../ExistingUserSuccess';

class ExsistingMember extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      membershipNumber: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      membershipNumberError: '',
      firstNameError: '',
      lastNameError: '',
      emailError: '',
      phoneNumberError: '',
      visible: true
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({ [name]: value });

    //if (name === 'membershipNumber') 
    //    this.validateMembershipNumber(value);

    //if (name === 'firstName')
    //    this.validateFirstName(value);

    //if (name === 'lastName')
    //    this.validateLastName(value);

    if (name === 'email')
      this.validateEmail(value);

    //if (name === 'phoneNumber')
    //    this.validatePhoneNumber(value);
  }

  validateEmail = (val) => {
    const emailErrorMessage = 'Valid email address is required';
    if (!validationService.isValidEmail(val)) {
      this.setState({ emailError: emailErrorMessage });
      return false;
    }
    this.setState({ emailError: '' });
    return true;
  }

  handleSubmit = (event) => {
    var url = `${ROOT_API_URL}/ManageMembershipRequest/SaveRequest`;
    axios.post(url, {
      MemberNumber: Number(this.state.membershipNumber),
      FirstName: this.state.firstName,
      LastName: this.state.lastName,
      Email: this.state.email,
      PhoneNumber: this.state.phoneNumber
    })
      .then((response) => {
        history.push('/existingMemberConfirmation');
        this.setState({
          success: true
        })
      })
      .catch((response) => {
        //this.props.dispatchError();
      });
    //if (this.validateEmail(this.state.email) &&
    //    this.validatePassword(this.state.password) &&
    //    this.validateCOnfirmPassword(this.state.passwordConfirm)) {
    //    const { dispatch } = this.props;
    //    dispatch(createAccount(this.state.email, this.state.password));
    //}

    event.preventDefault();
  }

  render() {
    return (
      <div>
        <div className="create-account">
          {this.props.error ? (
            <Alert
              color="red"
              isOpen={this.state.visible}
              style={{ position: 'fixed', width: '100%', color: 'white', backgroundColor: "#ff4444" }}
            >
              {this.props.error}
            </Alert>
          ) : null}
          {
            this.state.success ?
              <ExistingUserSuccess /> :
              <div className="create-account-content">
                <div>
                  <h1 className="text-left">Sign Up with Existing Membership</h1>
                  <p className="text-left">Please use this form to send us an existing membership sign-up request. We will review this information and if it matches a membership in our records, we will send you an account invitation.</p>
                  <p> A representative may contact you at the  provided phone number or email address for more information.</p>
                  <form onSubmit={this.handleSubmit} className="padding">
                    <FormGroup>
                      <Label htmlFor="firstName" xs={12}>First Name</Label>
                      <Col xs={12}>
                        <Input
                          required
                          type="text"
                          name="firstName"
                          id="firstName"
                          onChange={this.handleInputChange}
                          value={this.state.firstName}
                          placeholder="First Name"
                          invalid={this.state.firstNameError ? true : false} />
                        <FormFeedback>{this.state.firstNameError}</FormFeedback>
                      </Col>
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="lastName" xs={12}>Last Name</Label>
                      <Col xs={12}>
                        <Input
                          required
                          type="text"
                          name="lastName"
                          id="lastName"
                          onChange={this.handleInputChange}
                          value={this.state.lastName}
                          placeholder="Last Name"
                          invalid={this.state.lastNameError ? true : false} />
                        <FormFeedback>{this.state.lastNameError}</FormFeedback>
                      </Col>
                    </FormGroup>
                    <br />
                    <FormGroup>
                      <Label htmlFor="emailInput" xs={12}>Email Address</Label>
                      <Col xs={12}>
                        <Input
                          required
                          type="email"
                          name="email"
                          id="emailInput"
                          onChange={this.handleInputChange}
                          value={this.state.email}
                          placeholder="Email Address"
                          invalid={this.state.emailError ? true : false} />
                        <FormFeedback>{this.state.emailError}</FormFeedback>
                      </Col>
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="phoneNumber" xs={12}>Phone Number</Label>
                      <Col xs={12}>
                        <Input
                          required
                          type="text"
                          name="phoneNumber"
                          id="phoneNumber"
                          value={this.state.phoneNumber}
                          onChange={this.handleInputChange}
                          invalid={this.state.phoneNumberError ? true : false}
                          placeholder="Phone Number" />
                        <FormFeedback>{this.state.phoneNumberError}</FormFeedback>
                      </Col>
                    </FormGroup>
                    <br />
                    <FormGroup>
                      <Label htmlFor="membershipNumber" xs={12}>Membership Number</Label>
                      <Col xs={12}>
                        <Input
                          required
                          type="text"
                          name="membershipNumber"
                          id="membershipNumber"
                          onChange={this.handleInputChange}
                          value={this.state.membershipNumber}
                          placeholder="Membership Number"
                          invalid={this.state.membershipNumberError ? true : false} />
                        <FormFeedback>{this.state.membershipNumberError}</FormFeedback>
                      </Col>
                    </FormGroup>
                    <br />
                    <FormGroup>
                      <div className="v-space"></div>
                      <button className='btn btn-primary btn-block btnPrimary' type="submit" >
                        {
                          this.props.submitting
                            ? <SpanSpinner message="Submitting..." />
                            : <span>Submit</span>
                        }
                      </button>
                    </FormGroup>

                    <FormGroup>
                      <div className="v-space"></div>
                      <NavLink tag={RouterNavLink} className="btn btn-cancel btnPrimary" to="/home">Cancel</NavLink>
                    </FormGroup>



                  </form>
                </div>
              </div>
          }
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { submitting, error } = state.createAccount;
  return {
    submitting,
    error
  };
}

export default withRouter(connect(mapStateToProps)(ExsistingMember));